import { StepStatus } from 'types/migration';
import { FC } from 'react';

interface StatusChipProps {
  status: StepStatus;
}

const STATUS_COLORS: Record<StepStatus, string> = {
  PENDING: '#9e9e9e',
  IN_PROGRESS: '#004A98',
  COMPLETED: '#2e7d32',
  FAILED: '#d32f2f',
  CANCELLED: '#e65100',
  PARTIALLY_COMPLETED: '#f57f17'
};

const STATUS_BG: Record<StepStatus, string> = {
  PENDING: 'rgba(158,158,158,0.12)',
  IN_PROGRESS: 'rgba(0,74,152,0.08)',
  COMPLETED: 'rgba(46,125,50,0.08)',
  FAILED: 'rgba(211,47,47,0.08)',
  CANCELLED: 'rgba(230,81,0,0.08)',
  PARTIALLY_COMPLETED: 'rgba(245,127,23,0.08)'
};

const StatusChip: FC<StatusChipProps> = ({ status }) => (
  <span
    style={{
      display: 'inline-flex',
      alignItems: 'center',
      gap: 4,
      padding: '2px 10px',
      borderRadius: 12,
      fontSize: 11,
      fontWeight: 600,
      color: STATUS_COLORS[status],
      backgroundColor: STATUS_BG[status],
      textTransform: 'uppercase',
      letterSpacing: '0.5px'
    }}
  >
    {status === 'IN_PROGRESS' && (
      <span className="material-icons" style={{ fontSize: 14 }}>sync</span>
    )}
    {status === 'COMPLETED' && (
      <span className="material-icons" style={{ fontSize: 14 }}>check_circle</span>
    )}
    {status === 'FAILED' && (
      <span className="material-icons" style={{ fontSize: 14 }}>error</span>
    )}
    {status === 'PENDING' && (
      <span className="material-icons" style={{ fontSize: 14 }}>radio_button_unchecked</span>
    )}
    {status === 'CANCELLED' && (
      <span className="material-icons" style={{ fontSize: 14 }}>cancel</span>
    )}
    {status === 'PARTIALLY_COMPLETED' && (
      <span className="material-icons" style={{ fontSize: 14 }}>warning</span>
    )}
    {status}
  </span>
);

export default StatusChip;
